var $02989f2517098ef9$exports = {};
$02989f2517098ef9$exports = {
    "loading": `\u{8F09}\u{5165}\u{4E2D}\u{2026}`,
    "loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`
};


export {$02989f2517098ef9$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
